import { useLocalSearchParams } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { SuccessScreen } from '@/components/SuccessScreen';
import { Header } from '@/components/header';
import { VStack } from '@/components/ui/vstack';
import { ROUTES } from '@/constants/routes';
import { useColors } from '@/hooks/useColors';
import { useRedirectPath } from '@/hooks/useRedirectPath';

export default function Success() {
  const { email } = useLocalSearchParams<{ email: string }>();

  const { colors } = useColors();

  const { bottom } = useSafeAreaInsets();

  const { appendRedirectPath } = useRedirectPath();

  return (
    <VStack className="flex-1 bg-primary-500" style={{ paddingBottom: bottom }}>
      <Header
        headerShown={false}
        statusBarBackgroundColor={colors.primary[500]}
        statusBarStyle="light"
        contentStyle={{ backgroundColor: colors.primary[500] }}
      />
      <SuccessScreen
        heading="Check your email!"
        description={`If an account exists for ${email ?? 'that address'}, we've sent a sign-in link. If you normally sign in with Google, use the "Continue with Google" button on the login page instead.`}
        riveAnimation="LOGO_FLOW_LIGHT_GREEN"
        buttonText="Back to sign-in"
        buttonHref={appendRedirectPath(ROUTES.LOGIN)}
      />
    </VStack>
  );
}
